<template class='chat-rooms'>

  <div>
    <div id="people-list" class="people-list">
        <div class="search">

        <div v-if="1!==1" class="text-center">
        <b-button v-b-modal.newPublicChat class="mt-2"> <i class="fa fa-2x fa-users"></i><i class="fa fa-plus fa-plus text-success"></i></b-button>
        <b-button v-b-modal.newChat class="mt-2"><i class="fa fa-plus fa-2x"></i></b-button>
        </div>
      </div>
                <b-form-input type="text" v-model="searchString" class="my-2" placeholder="Поиск"/>
        <transition-group class="list" name="flip-list" tag="ul">
            <div class="row start_dialog" style="overflow-y: hidden;" v-for="(room,index) of rooms" v-bind:key="room.id" v-bind:class="{ unread: room.read && room.read.indexOf($auth.user().profile.user_id) == -1 }">
                
                <a href='#' style="width:100%; overflow-y: hidden;" >
                    <button @click.prevent="closeRoom(room.id,index)" class="close_chat text-danger float-right btn btn-sm btn-outline btn-outline-colorless b-a-0" data-toggle="tooltip" title="Закрыть чат"><i class="fa fa-close"></i></button>
                    <span v-on:click.prevent="setRoom(room.id,index); $emit('open-room', room.id); ">
                    <div v-if="room.data.type==='private'" class="status" style="position: absolute;">
                        <i class="fa fa-circle" v-bind:class="[room.data.online ? 'online' : 'offline']"></i>
                    </div>
                    <b-img :src="avatar(room)" style="width:55px; float:left;  margin: 10px;" rounded="circle"/><b class="name">{{name(room)}}</b>
                    <div v-if="room.message" class="message_text" style="border-radius: 10px; margin-right: 15px; margin-left: 5px;  display: table;"> <img v-if="room.from==$auth.user().profile.user_id" :src="$auth.user().profile.avatar" style="width:40px; border-radius: 40px;" ><span v-html="JSON.parse(room.message).message"></span></div>
                    </span>                    
                </a>
            </div>
       <infinite-loading :on-infinite="infiniteRooms" key="loader">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
        </transition-group>

    </div>
    
      <b-modal id="newChat" ref="newChat" lazy hide-footer @show="fetchUsers()" title="Создать чат">

            <div class="input-group mb-3" id="search_string">
                <input style="border-radius: 0rem;" type="text" v-on:keyup="searchUser()"  v-model="chatSearchString.name" class="form-control" :placeholder="$t('name')" :aria-label="$t('search')" >
                <div class="input-group-append">
                    <button type="submit" class="btn btn-primary" id="users-search-button"><i class="fa fa-search"></i></button>
                </div>
            </div>
            <div v-for="user in searchUsers" class="my-2" style="display: flex;">

            <div class="card" style=" width:100%">
                <div class="card-body" style=" width:100%">
              <img :src="user.avatar" alt="" class="" style="width:96px; height:96px; border-radius: 3px; float: left;margin-right: 10px;">
                  <div class="widget-followers-controls">
                    <a v-on:click="startChat(user.user_id)" href="#" class="btn btn-sm btn-primary">
                      <i class="fa fa-plus"></i>&nbsp;&nbsp;Начать диалог
                    </a>
                  </div>           
                    <div class="widget-followers-name">
                      <router-link class="font-size-16" :to="{ path: '/@' + user.user_id }">{{user.name}}</router-link>
                      <div class="text-muted font-size-12 inline"><span class="label label-xs label-danger inline status">Не в сети</span></div></div>
              <a href="#" class="widget-followers-username">@{{user.user_id}}</a>
                </div>
            </div>
          </div>
  </b-modal>
      <b-modal id="newPublicChat" hide-footer lazy title="Создать групповой чат">
          <newPublicChat v-on:newPublic="newPublicRoom"></newPublicChat>
      </b-modal>
  </div>
</template>






<script>
  import vSelect from 'vue-select'
  import newPublicChat from './newPublicChat'
const debounce = function (f, ms) {
  let timer = null;
  return function (...args) {
      const onComplete = () => {
          f.apply(this, args);
          timer = null;
      }
      if (timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(onComplete, ms);
  };
}
//  Import axios
import InfiniteLoading from 'vue-infinite-loading'
const api = 'chat/rooms-list'
export default {
  name: 'chat-rooms',
  components: {
    InfiniteLoading,
    newPublicChat
  },
  data () {
    return {
      rooms: [],
      errors: [],
      busy: false,
      searchString:null,
      page: 1,
      searchUsers: [],
      new_dialog_with: null,
      chatSearchString: {},
      users:[],
      no_ava: 'https://scispace.hb.bizmrg.com/uploads/avatars/no_avatar.png',
      no_group_ava: 'https://linksys.i.lithium.com/t5/image/serverpage/image-id/16800i3E8B46D91CD0CF26/image-size/original?v=1.0&px=-1'
    }
  },
  watch: {
    searchString () { this.search() },
    '$store.state.lastMessage' () {
        var index = this.rooms.findIndex( x => x.id == this.$store.state.lastMessage.room_id )
        
        if(index!==-1){
            this.rooms.unshift(...this.rooms.splice(index,1));
            this.rooms[0].message = JSON.stringify({message:this.$store.state.lastMessage.data.message});
            if(this.$store.state.open_room_id!==this.rooms[0].id)
            {
               this.rooms[0].read='[]'
            }
            
        }
        else
        {
          if(this.$auth.user().profile.user_id===this.$store.state.lastMessage.from)
          {    
                  var avatar=this.$store.state.open_room.data.avatar
                  var name=this.$store.state.open_room.data.name          
          }
          else
          {
              if(this.$store.state.lastMessage.data.type==='private')
              {
                  var avatar=this.$store.state.lastMessage.user.avatar
                  var name=this.$store.state.lastMessage.user.name
              }
              else
              {
                  var avatar=this.$store.state.lastMessage.data.avatar
                  var name=this.$store.state.lastMessage.data.name
              }
          }
            var obj={id:this.$store.state.lastMessage.room_id,
            message: JSON.stringify({message:this.$store.state.lastMessage.data.message}),
            data: {avatar: avatar, name: name, type:this.$store.state.lastMessage.room_type},
            from:this.$store.state.lastMessage.from,
            read:JSON.stringify([])}
            this.rooms.unshift(obj)
          
        }
    }
        //this.rooms.map(mapObj => mapObj['name']).indexOf(obj['name']) === pos }
        //$state.messages.room_id this.rooms.unshift(...this.rooms.splice(3,1));
  },
  // Fetches posts when the component is created.
  methods: {
    shuffle: function () {
        this.rooms.unshift(...this.rooms.splice(3,1));
     //this.rooms = _.shuffle(this.rooms)
    },
    closeRoom(room_id,index){
        this.$http.post('chat/close-room?room_id='+room_id).then(({ data }) => {
        this.rooms.splice(index,1)
      })

    },
    setRoom(room_id,index){
      var read=JSON.parse(this.rooms[index].read);
      if(read.indexOf(this.$auth.user().profile.user_id) ==-1)
      {
        this.rooms[index].read=JSON.stringify(read.concat(this.$auth.user().profile.user_id))
      }
    },
    newPublicRoom (name,id){
            var obj={id:id,
            message: JSON.stringify({message:null}),
            data: {avatar: null, name: name, type:'public'},
            from:null,
            read:JSON.stringify([])}
            this.rooms.unshift(obj)
    },
    avatar(room)
    {
        if(room.data.avatar)
        {
          return room.data.avatar
        }
        if(room.data.type=='private')
        {
            return this.no_ava
        }
        else
        {
            return this.no_group_ava
        }
    },
    name(room)
    {
        if(room.data.name)
        {
          return room.data.name
        }
        if(room.data.type=='private')
        {
            return 'Без имени'
        }
        else
        {
            return 'Групповой чат'
        }
    },
    search: debounce(function () {
      this.fetchData()
    }, 500),
    fetchData () {
            this.page=1
            this.rooms=[]
            this.infiniteId += 1;
      this.$http.post('chat/rooms-list?page=' + this.page, 
          {search: this.searchString}
        ).then(( response ) => {
        if (response.data.length) {

          this.rooms.push(...response.data)
        }
      })
    },
    infiniteRooms ($state) {
         this.$http.post('chat/rooms-list?page=' + this.page, 
          {search: this.searchString}
        ).then(( response) => {
        if (response.data.length) {
          this.page += 1;
          this.rooms.push(...response.data)
          $state.loaded();
        } else {
          $state.complete();
        }
      })
    },
    searchUser: debounce(function () {
      this.fetchUsers()
    }, 500),
    fetchUsers() {
      this.searchUsers=[]
      this.$http.post('social/user-search?tab=all&page=1', 
          {UserSearch: this.chatSearchString}
        ).then(({ data }) => {
        if (data.length) {
          this.usersPage += 1;
          this.searchUsers.push(...data);
        }
      })
    },
    startChat(user_id){
       this.$http.post('chat/get-room?user_id='+user_id).then(({ data }) => {
        this.$store.state.open_room_id=data
        this.$refs.newChat.hide()
      })
    }
  }
}
</script>
<style scoped>

    .flip-list-move {
  transition: transform 1s;
}
  .unread {
    background-color: #f0f0f0;
    border-radius: 5px;
}

.people-list ul {
  padding: 20px;
}
.people-list ul li {
  padding-bottom: 20px;
}
.people-list img {
  float: left;
  margin-right: 10px;
}
.people-list .about {
  float: left;
  margin-top: 8px;
}
.people-list .about {
  padding-left: 8px;
}
.people-list .status {
  color: #92959e;
}
.people-list input {
  //border-radius: 3px;
  //border: none;
  //padding: 14px;
  //color: white;
  //background: #6a6c75;
  //width: 70%;
  //font-size: 14px;
}

.online {
  color: #86bb71;
}

.offline {
  color: #e46050;
}
.start_dialog {
    max-height: 110px;
    border-bottom: 0.5px solid #c1c1c1;  
    padding:5px;
}
 
  .widget-followers-controls {
    float: right;
    bottom: 20px;
    position: absolute;
    right: 11px;
    border-radius: 10px;
}
</style>